import { FlexTemplateNode, FlexTemplateNodeProps, FlexTemplateRenderer } from 'flex-template-renderer-react';
import * as React from 'react';

import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from 'uitk-react-layout-grid';

interface FlexTemplate extends FlexTemplateNode {
  childNodes: FlexTemplateNode[];
  options: {
    colSpan: number;
  };
}

export interface LayoutGridItemProps extends FlexTemplateNodeProps {
  flexTemplateNode: FlexTemplate;
}

export const LayoutGridItem: React.FC<LayoutGridItemProps> = (props: LayoutGridItemProps) => {
  const { childNodes, options } = props.flexTemplateNode;

  return (
    <UitkLayoutGridItem colSpan={options.colSpan as UitkLayoutConditionalGridSpan}>
      <div>{childNodes && <FlexTemplateRenderer template={childNodes} />}</div>
    </UitkLayoutGridItem>
  );
};
